import { RoomData } from "@/types/call";
import { ShallowReactive } from "vue";
import { closeTheOnlyRoom } from "./closeTheOnlyRoom";

export const removeRoom = (data: ShallowReactive<RoomData>) => {
  closeTheOnlyRoom();
  data.room?.disconnect();
};
